// memberDetail/container.js
import React, { useState } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { updateMembershipProfile } from 'api';
import MemberDetailView from './view';

const MemberDetail = ({
  member,
  open,
  onClose,
  isAdmin,
  onMemberUpdate, // Callback to notify parent that member was updated
}) => {

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success'
  });

  const showSnackbar = (message, severity = 'success') => {
    setSnackbar({ open: true, message, severity });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // Helper to get readable role names
  const getRoleName = (roleCode) => {
    const roleNames = {
      'FO': 'Founder',
      'AD': 'Admin',
      'MA': 'Manager',
      'PT': 'Partner',
      'EO': 'Event Organizer',
      'PA': 'Member',
      'GU': 'Guest'
    };
    return roleNames[roleCode] || roleCode;
  };

  const handleMemberAction = async (action, data) => {
    
    if (!member) {
      console.error('No member available');
      return;
    }

    try {
      switch (action) {
        case 'changeRole':

          const roleResponse = await updateMembershipProfile(member.slug, {
            role: data.newRole
          });

          
          if (roleResponse.success) {
            showSnackbar(`Role changed to ${getRoleName(data.newRole)} successfully!`, 'success');
            
            // Notify parent that member was updated
            if (onMemberUpdate) {
              onMemberUpdate('role_changed', member.slug, roleResponse);
            }
          } else {
            showSnackbar(`Failed to change role: ${roleResponse.error}`, 'error');
          }
          break;

        case 'remove':

          const removeResponse = await updateMembershipProfile(member.slug, {
            status: 'DL'
          });


          if (removeResponse.success) {
            showSnackbar('Member removed successfully', 'success');
            
            // Close the modal
            onClose();
            
            // Notify parent that member was removed
            if (onMemberUpdate) {
              onMemberUpdate('removed', member.slug, removeResponse);
            }
          } else {
            showSnackbar('Failed to remove member', 'error');
          }
          break;

        default:
      }
    } catch (error) {
      console.error('Error performing member action:', error);
      showSnackbar(`Error: ${error.message || 'Something went wrong'}`, 'error');
    }
  };

  return (
    <>
      <MemberDetailView
        member={member}
        open={open}
        onClose={onClose}
        isAdmin={isAdmin}
        onMemberAction={handleMemberAction}
      />

      {/* Snackbar for member detail actions */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert 
          onClose={handleCloseSnackbar} 
          severity={snackbar.severity}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default MemberDetail;